// src/components/Layout.jsx
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopNav from './TopNav';
import Footer from './Footer';
import InactivityWatcher from './InactivityWatcher';
import { useProfile } from 'context/ProfileContext';
import { useAppAccess } from 'context/AppAccessContext';

export default function Layout() {
  const { profile, selectedOrg, loading: profileLoading } = useProfile();
  const { apps, loading: appsLoading } = useAppAccess();

  // Default to collapsed (icons-only)
  const [collapsed, setCollapsed] = useState(true);

  const mainPadding = collapsed ? 'pl-16' : 'pl-48';

  // only hide UI when logout is active, no profile, and not still loading
  const logoutInProgress = sessionStorage.getItem('logoutInProgress');
  const isLoading = profileLoading || appsLoading;
  if (logoutInProgress && !profile && !isLoading) {
    return <div className="min-h-screen bg-app" />;
  }

  return (
    <>
      <Sidebar
        profile={profile}
        apps={apps}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        loading={isLoading}
      />
      <div
        className={`flex flex-col min-h-screen bg-surface text-app ${mainPadding}`}
      >
        <TopNav profile={profile} apps={apps} />
        <main className="flex-1 p-0 overflow-x-clip">
          {isLoading ? (
            <div className="flex items-center justify-center h-full p-6">
              <div className="card p-6">Loading…</div>
            </div>
          ) : (
            <Outlet key={selectedOrg?.id || "no-organization"} />
          )}
        </main>
        <Footer />
        <InactivityWatcher />
      </div>
    </>
  );
}
